<template>
  <StepComponent>
    <PackageSelection @state-change="onPackageChange" />
  </StepComponent>
</template>

<script>
import StepComponent from "@/components/newSamples/SampleWizardSteps/StepComponent";
import PackageSelection from "@/components/newSamples/SampleWizardSteps/SampleStepComponents/PackageSelection";
import { mapActions, mapState } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "PackageSelectionStep",
  components: { StepComponent, PackageSelection },
  methods: {
    ...mapActions("samples", ["updateSampleSet", "setActive"]),
    ...mapActions(["notify"]),
    ...mapActions("samples", ["editBulkSamples"]),
    beforeContinue() {
      if (this.isBulk) {
        this.payloadTestPackages =
          this.active_sample.test_packages.length > 0
            ? this.active_sample.test_packages.map(item => item.id).join(", ")
            : "";
        this.payloadTestComponents =
          this.active_sample.test_components.length > 0
            ? this.active_sample.test_components.map(item => item.id).join(", ")
            : "";
        this.payloadRemovedTestComponents =
          this.removedTestComponents.length > 0
            ? this.removedTestComponents.join(", ")
            : "";
        this.payloadRemovedTestPackages =
          this.removedTestPackages.length > 0
            ? this.removedTestPackages.join(", ")
            : "";
      }
      if (
        this.active_sample.test_components.length > 0 ||
        this.active_sample.test_packages.length > 0
      )
        if (!this.isBulk) {
          return this.updateSampleSet("package").then(res => {
            return !!res;
          });
        } else {
          return this.saveBulkPackagesAndComponents();
        }
      else {
        const message = "Please Add Package(s) and/or Component(s)";
        this.notify({ message });
        return false;
      }
    },
    async saveBulkPackagesAndComponents() {
      const result = await this.editBulkSamples({
        ids: this.sampleIds,
        test_packages: this.payloadTestPackages,
        test_components: this.payloadTestComponents,
        removed_components: this.payloadRemovedTestComponents,
        removed_packages: this.payloadRemovedTestPackages
      });

      if (result.success) {
        Promise.all([this.setActive(this.sampleIds[0])]).then(data => {
          if (data.includes(false)) {
            this.error.message =
              "An error occurred while retrieving this sample";
          } else {
            this.lab_id_start = this.active_sample.slug;
          }
        });
        return true;
      } else {
        if (result?.errors && result?.errors.length) {
          this.notify({
            message: `Failed to add bulk samples packages and components! ${result.errors.join(
              ", "
            )}`,
            color: "error"
          });
          return false;
        }
        if (result?.message) {
          this.notify({
            message: `Failed to add bulk samples packages and components! ${result.message}`,
            color: "error"
          });
          return false;
        }
      }
    },
    onPackageChange(change) {
      if (change.type === "components") {
        this.removedTestComponents = change.removed;
      }
      if (change.type === "packages") {
        this.removedTestPackages = change.removed;
      }
    }
  },
  computed: {
    ...mapState("samples", ["active_sample"]),
    ...mapFields("sampleWizard", [
      "wizard.isBulk",
      "wizard.sampleIds",
      "wizard.barcode_start",
      "wizard.barcode_end",
      "wizard.lab_id_start",
      "wizard.lab_id_end"
    ])
  },
  data() {
    return {
      removedTestPackages: [],
      removedTestComponents: [],
      payloadTestPackages: "",
      payloadTestComponents: "",
      payloadRemovedTestComponents: "",
      payloadRemovedTestPackages: ""
    };
  }
};
</script>
